module.exports = __webpack_public_path__ + "static/img/iconfont.ca49cd0d.svg";